import { render, staticRenderFns } from "./SalesAccountList.vue?vue&type=template&id=4d2bbdf6&scoped=true"
import script from "./SalesAccountList.vue?vue&type=script&lang=js"
export * from "./SalesAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2bbdf6",
  null
  
)

export default component.exports